import { memoizeFunction } from '../../Utilities';
import { mergeStyleSets } from '../../Styling';
export var getDividerClassNames = memoizeFunction(function (theme) {
    return mergeStyleSets({
        wrapper: {
            display: 'inline-flex',
            height: '100%',
            alignItems: 'center'
        },
        divider: {
            width: 1,
            height: '100%',
            backgroundColor: theme.palette.neutralTertiaryAlt
        }
    });
});
//# sourceMappingURL=VerticalDivider.classNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Divider/VerticalDivider.classNames.js
// module id = 132
// module chunks = 0